// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AuthLayout_wrapper__Lb7mw","bgImageWrapper":"AuthLayout_bgImageWrapper__PE1vr","formWrapper":"AuthLayout_formWrapper__3Njti"};